<template>
  <div class="modal-parent">
    <loading
      v-model:active="loading"
      :can-cancel="true"
      :is-full-page="fullPage"
      color="#669933"
      loader="spinner"
    />
    <!-- Header section -->
    <section class="header">
      <div class="" style="margin: 0 auto; width: 96%">
        <div class="header-content">
          <h5 class="modal-caption">Dispatch Details</h5>

          <div class="logo-container">
            <img src="../../assets/releaf-logo.png" alt="" />
          </div>

          <div class="icons-container">
            <div class="" style="cursor: pointer">
              <img
                src="../../assets/edit-icon.png"
                alt=""
                @click="openEditModal"
              />
            </div>
            <div class="" style="cursor: pointer" @click="openDeleteModal">
              <img src="../../assets/delete-icon.png" alt="" />
            </div>
            <div
              class="x-container"
              style="cursor: pointer"
              @click="closeModal"
            >
              <img src="../../assets/x-icon.png" alt="" />
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- border -->
    <div class="border"></div>

    <!-- Dispatch details -->
    <section class="dispatch-details" v-if="dispatch">
      <div class="" style="margin: 0 auto; width: 96%">
        <div class="details">
          <div class="details__section">
            <InfoBox header="Verified Tonnage" :info="dispatch.verifiedTonnage" class="div1" />
            <InfoBox header="Factory" :info="dispatch.factory" class="div2" />
            <InfoBox
              header="Quantity Moved"
              :info="dispatch.qtyMoved + ' Ton(s)'"
              class="div3"
            />
            <InfoBox header="Vehicle" :info="dispatch.vehicle" class="div4" />
            <InfoBox
              header="Created By"
              :info="dispatch.createdBy"
              class="div5"
            />
            <InfoBox header="Driver" :info="dispatch.driver" class="div6" />
            <InfoBox
              header="Approval"
              :info="dispatch.authorisationStatus"
              class="div7"
            />
            <InfoBox
              header="Start Date"
              :info="dispatch.startDate"
              class="div8"
            />
            <InfoBox header="End Date" :info="dispatch.endDate" class="div9" />
            <InfoBox header="Dispatch Status" info="Completed" class="div10" />
            <InfoBox
              header="Loader Cost"
              :info="vueNumberFormat(dispatch.loaderCost, {})"
              class="div11"
            />
            <InfoBox
              header="Fuel Cost"
              :info="vueNumberFormat(dispatch.fuelCost, {})"
              class="div12"
            />
            <InfoBox
              header="Checkpoint Cost"
              :info="vueNumberFormat(dispatch.checkPointCost, {})"
              class="div13"
            />
            <InfoBox
              header="Community Cost"
              :info="vueNumberFormat(dispatch.communityCost, {})"
              class="div14"
            />
            <InfoBox
              header="Offloading Cost"
              :info="vueNumberFormat(dispatch.offloadingCost, {})"
              class="div15"
            />
            <InfoBox
              header="Imprest Cost"
              :info="vueNumberFormat(dispatch.imprestCost, {})"
              class="div16"
            />
          </div>
        </div>
      </div>
    </section>

    <section class="actions-container">
      <div class="" style="margin: 0 auto; width: 96%">
        <h6 class="action-section-header">Actions</h6>

        <div class="green-border"></div>

        <div class="action-buttons-container">
          <InvertedBlackButton
            label="Reject"
            width="8.4rem"
            height="2.9rem"
            class="action-button"
            labelColor="#fff"
            bgColor="#ED0A0A"
            @click="rejectDispatchEntry"
          />

          <GreenButton
            v-if="dispatch.authorisationStatus === 'Pending'"
            label="Approve"
            width="8.4rem"
            height="2.9rem"
            class="action-button"
            labelColor="#669933"
            @click="approveDispatchEntry"
          />

          <InvertedBlackButton
            v-if="
              dispatch.authorisationStatus === 'Approved' &&
              dispatch.verificationStatus === 'Pending'
            "
            label="Verify"
            width="8.4rem"
            height="2.9rem"
            class="action-button"
            labelColor="#669933"
            @click="openVerifyModal"
          />
        </div>
      </div>
    </section>

    <!-- Dispatch details -->
  </div>
</template>

<script>
import InfoBox from "../../components/info-box/InfoBox.vue";
import InvertedBlackButton from "../../components/buttons/inverted-black-button/InvertedBlackButton.vue";
import GreenButton from "../../components/buttons/green-button/GreenButton.vue";
import { createToast } from "mosha-vue-toastify";
import Loading from "vue-loading-overlay";

export default {
  name: "DispatchDetailsModal",

  components: { InvertedBlackButton, InfoBox, GreenButton, Loading },

  data() {
    return {
      modalStatus: "",
      dispatch: {},
      loading: false,
    };
  },

  props: {
    dispatchId: {
      type: String,
      required: true,
    },
  },

  mounted() {
    this.fetchDispatch();
  },

  methods: {
    closeModal() {
      this.$emit("onCloseModal", false);
    },

    async approveDispatchEntry() {
      const payload = {
        id: this.dispatchId,
        isApproved: true,
        authorisationStatus: "Approved",
      };

      this.loading = true;
      const data = await this.$store.dispatch(
        "dispatch/updateDispatch",
        payload
      );

      if (data.id) {
        this.loading = false;
        window.location.reload();
        createToast("Dispatch Approved successfully!", {
          type: "success",
          timeout: 3000,
          position: "top-right",
          onClose: () => {
            return window.location.reload();
          },
        });
      }
    },

    openEditModal() {
      this.$emit("onCloseModal", false);
      this.$store.dispatch("dispatch/findDispatchToBeUpdated", this.dispatchId);
      this.$store.dispatch("dispatch/setEditModalStatus", true);
      this.$store.dispatch("dispatch/setActiveLogisticsTab", "Dispatch");
    },

    openVerifyModal() {
      this.$emit("onCloseModal", false);
      this.$store.dispatch("dispatch/findDispatchToBeUpdated", this.dispatchId);
      this.$store.dispatch("dispatch/setVerifyModalStatus", true);
      this.$store.dispatch("dispatch/setActiveLogisticsTab", "Dispatch");
    },

    async rejectDispatchEntry() {
      const payload = {
        id: this.dispatchId,
        authorisationStatus: "Rejected",
      };

      this.loading = true;

      const data = await this.$store.dispatch(
        "dispatch/updateDispatch",
        payload
      );

      if (data.id) {
        this.loading = false;
        createToast("Dispatch Rejected successfully!", {
          type: "success",
          timeout: 3000,
          position: "top-right",
          onClose: () => {
            return window.location.reload();
          },
        });
      }
    },

    openDeleteModal() {
      this.$emit("onCloseModal", false);
      this.$store.dispatch("dispatch/updateDeleteModalStatus", true);
      this.$store.dispatch("dispatch/setDispatchId", this.dispatchId);
      this.$store.dispatch("dispatch/setActiveLogisticsTab", "Dispatch");
    },

    async fetchDispatch() {
      const dispatchId = this.dispatchId;
      this.loading = true;

      try {
        const dispatch = await this.$store.dispatch(
          "dispatch/fetchOneDispatch",
          dispatchId
        );
        this.dispatch = {
          ...this.dispatch,
          ...dispatch,
        };
        this.loading = false;
      } catch (error) {
        console.log(error.message);
      }
    },
  },
};
</script>

<style scoped>
.modal-parent {
  background-color: white;
  height: 100%;
}

.header-content,
.details,
.contents {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.details,
.header-content {
  padding: 5px;
}

.modal-caption {
  color: #232a34;
  font-weight: 700;
}

.logo-container {
  background-color: #232a34;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.logo-container img {
  width: 30px;
  height: auto;
}

.icons-container {
  display: flex;
  justify-content: space-between;
  /* border: 1px solid red; */
  width: 19%;
}

.x-container:hover {
  background: #e8e8e8;
}

.border,
.green-border {
  margin-top: 10px;
  background: #ffffff;
  width: 100%;
}

.border {
  border-bottom: 1px solid #b3b3b3;
}

.green-border {
  border-bottom: 2px dotted #669933;
}

.dispatch-details {
  height: 70%;
}

.details__section {
  margin-top: 15px;
  width: 100%;
  height: 220px;

  display: grid;
  grid-template-columns: repeat(auto-fit, 1fr);
  grid-template-rows: repeat(4, 1fr);
  grid-column-gap: 30px;
  grid-row-gap: 20px;
  padding: 0px;
  /* border: 1px solid black; */
}

.div1 {
  grid-area: 1 / 1 / 2 / 2;
}
.div2 {
  grid-area: 1 / 2 / 2 / 3;
}
.div3 {
  grid-area: 1 / 3 / 2 / 4;
}
.div4 {
  grid-area: 1 / 4 / 2 / 5;
}
.div5 {
  grid-area: 2 / 1 / 3 / 2;
}
.div6 {
  grid-area: 2 / 2 / 3 / 3;
}
.div7 {
  grid-area: 2 / 3 / 3 / 4;
}
.div8 {
  grid-area: 2 / 4 / 3 / 5;
}
.div9 {
  grid-area: 3 / 1 / 4 / 2;
}
.div10 {
  grid-area: 3 / 2 / 4 / 3;
}
.div11 {
  grid-area: 3 / 3 / 4 / 4;
}
.div12 {
  grid-area: 3 / 4 / 4 / 5;
}
.div13 {
  grid-area: 4 / 1 / 5 / 2;
}
.div14 {
  grid-area: 4 / 2 / 5 / 3;
}
.div15 {
  grid-area: 4 / 3 / 5 / 4;
}
.div16 {
  grid-area: 4 / 4 / 5 / 5;
}

.actions-container {
  margin-top: 100px;
  /* display: inline-block; */
}

.action-section-header {
  color: #669933;
  font-weight: 900;
  padding-left: 10px;
  font-size: 23px;
}

.action-buttons-container {
  display: flex;
  align-items: center;
  padding: 20px 10px;
}

.action-button {
  margin-right: 15px;
}
</style>
